import { majorOf, type CatalogItem, type ItemDraft } from "./useStock";

/**
 * The shape of an item being defined, as the FORM holds it — numbers as typed
 * strings, so a half-entered "8." is not a NaN and an emptied field is an
 * empty field rather than a zero. Converted to minor units at the boundary,
 * once, on save.
 */
export interface Draft extends ItemDraft {
  /** Major units as typed — "38.00". Converted at the boundary. */
  cost: string;
  min: string;
  threshold: string;
  orderQty: string;
}

export const emptyDraft = (): Draft => ({
  name: "",
  category: null,
  unit: null,
  barcode: null,
  batchTracked: false,
  preferredSupplierId: null,
  autoOrderEnabled: false,
  cost: "",
  min: "",
  threshold: "",
  orderQty: "",
});

export const draftOf = (item: CatalogItem): Draft => ({
  name: item.name,
  category: item.category,
  unit: item.unit,
  barcode: item.barcode,
  batchTracked: item.batchTracked,
  preferredSupplierId: item.preferredSupplierId,
  autoOrderEnabled: item.autoOrderEnabled,
  cost: majorOf(item.standardCostMinor),
  min: item.minLevel == null ? "" : String(item.minLevel),
  threshold:
    item.autoOrderThreshold == null ? "" : String(item.autoOrderThreshold),
  orderQty:
    item.autoOrderQuantity == null ? "" : String(item.autoOrderQuantity),
});
